module.exports = __webpack_public_path__ + "img/informationen_paedagogik.0105ec64.png";